import { DateTime } from "luxon";
import React from "react";

export const WorkshopCardContainer = ({ data ,monthValue}: any) => {
  const { joined_users, joining_percentage, total_workshop } = data;
  function getMonthName(dateString: string) {
    const date = DateTime.fromISO(dateString);
    return date.toFormat("MMMM");
  }

  const localData = localStorage.getItem("userdata") ||JSON.stringify({accessCode:""}) ;
  const access_code = JSON.parse(localData).accessCode ;

  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "25px 0 25px 0",
        borderRadius: "5px",
      }}
    >
      <div
        style={{
          fontSize: "20px",
          padding: "15px 25px",
          borderBottom: "1px solid #eeeff2",
        }}
      >
        {monthValue ? getMonthName(monthValue)  :"Overall Numbers"}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px 25px",
          marginTop: "15px",
        }}
      >
        <div>Total workshops conducted</div>
        <div style={{ fontSize: "30px" }}>{total_workshop}</div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px 25px 15px 25px",
        }}
      >
        <div>No. of {access_code? "Employees":"Users"} joined</div>
        <div style={{ fontSize: "30px" }}>{joined_users}</div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px 25px 15px 25px",
        }}
      >
        <div style={{ flex: 1 }}>
          <div style={{ maxWidth: "70%" }}>
            Average no. of employee joining workshop
          </div>
        </div>
        <div style={{ fontSize: "30px" }}>{joining_percentage|| "0"}</div>
      </div>
    </div>
  );
};
